import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 1205 384.7",
    }}
    viewBox="0 0 1205 384.7"
    {...props}
  >
    <style>
      {
        ".st1{clip-path:url(#SVGID_00000137855113667755547560000006382394116346838402_)}.st2{clip-path:url(#SVGID_00000085969051752441035770000014719662521926632625_)}.st3{fill:url(#SVGID_00000132787969030021576660000016587845580879164307_)}.st4{fill:url(#SVGID_00000090977669137382712860000010413835602767361468_)}.st5{fill:url(#SVGID_00000079469155377298232320000009220644609631060380_)}.st6{fill:url(#SVGID_00000013153194327341523400000008332980557156069297_)}.st7{fill:url(#SVGID_00000039107112066711332970000011525489328047479953_)}.st8{fill:url(#SVGID_00000089568967562539295870000013788582515403250873_)}.st9{fill:url(#SVGID_00000009574678323836657850000003734823393712674698_)}.st10{fill:url(#SVGID_00000124884712810125899460000006672284932901655737_)}.st11{fill:url(#SVGID_00000162338296093154799930000004942585932099944101_)}.st12{fill:url(#SVGID_00000079487515865964777900000013685221440803489197_)}"
      }
    </style>
    <path d="M135.3 327.5c74.7 0 135.3-60.6 135.3-135.3 0-74.7-60.6-135.3-135.3-135.3C60.6 56.9 0 117.5 0 192.2c0 74.7 60.6 135.3 135.3 135.3z" />
    <path
      d="M204.5 106.1C195.3 85 169.2 76 146.1 86c-15 6.5-25 19.4-27.6 33.5-.6 2.4-.8 5-.8 7.6-1.9-.5-1.9-.5-1.2-.3-15.1-3.2-37.2 7.7-42.6 22.2-.8 1.7-1.3 3.6-1.6 5.6-.3 2-.4 3.9-.2 5.8-5 5.5-26.1 34.7-29.2 38h-.1c-1.5.2-2.8 1.2-3.2 2.6-.2.7-.3 1.4-.1 2.1.3 1.1 1.1 1.9 2.1 2.3l-.2.2c2-.2 27.7 66 27.7 66l-23.3-66.8c1.2-.9 1.8-2.4 1.3-3.9-.2-.5-.4-.9-.7-1.3 4.2-2.6 21.7-25.4 27.6-32.4 1.4 2.8 3.4 5.1 5.8 6.6l.3.6c-1.2 1.8-2.7 3.8-2.8 3.8-1.3.1-2.2 1.2-2.1 2.5.1 1.2 1 2 2.2 2.1 3.5 10 13.6 56.8 13.6 56.8l-10.6-59.9c.3-.6.7-1.3 1.2-2.1l16.5 38-15.7-39.2c.3-.4.6-.7.9-1 .2.1.5.1.8.2 4.4 2.7 10.4 4.4 17.2 4.7 1.9 10.2 5.2 47.7 5.2 47.7l-2.3-47.6c1.5 0 3.1-.1 4.7-.2 6.8-.6 13-2.4 18-5l5.6 6.7s6.4 10.9 11.3 19c-.2.6-.2 1.2-.2 1.8.1 1.5.9 2.7 2 3.4l.2 7.4-.2.5.2-.5 2.5 104.6 5.3-115.1c1.2-1.7 0 0 .1-3-.2-.1-.4-.2-.5-.4l12.6-23.8c5.9 4 11.6 8 15.8 11l-9 77.5 7.6-43.5-6.5 56.4 15.2-86.8c.3-1.4.7-3.6 1.1-6.2-.8-.2-1.9-.7-3.2-1.4l.6-3.3c.4-.6.6-1.6.5-2.6-.2-1.9-1.2-3.3-2.4-3.2-.2 0-.5.1-.7.3-.2-.1-.3-.1-.4-.2l-.7-.2-.6-.4c-3.1-1.4-7.6-4-12.4-6.9l1.8-3.4s.2-.2.2-.4c.2-.7-.2-1.4-.9-1.7-.2-.1-.4-.1-.7 0l-3.3-1.6c4-1 8-2.4 12-4 23.1-10 34-28 24.9-49.2h-.2zm-22.3 72.8-.1 1.2c-3.2-2.1-6.9-4.7-10.8-7.6 4.7 2.6 8.6 5 10.9 6.4zm-29.7 20.5c-7.5-5.5-12.8-20-18.4-29.7 2.5-2.8 3.8-5.9 3.6-9.2 0-.2-.1-.4-.1-.7 5.4 1.5 16.4 8.3 26.8 15.3l-11.9 24.3zm17.4-36.7c.1.2.2.4.4.6l-1.2 2.4c-2.6-1.6-5.3-3.3-7.8-5 .7-.1 1.4-.2 2.2-.4l6.4 2.4z"
      style={{
        fill: "#fff",
      }}
    />
    <path d="M404.1 144.5h10.5v42.4h47.2v-42.4h10.5v96.6h-10.5V196h-47.2v45.1h-10.5v-96.6zM520.6 208.8l-36.1-64.3h11.2l30 53.1h.6l31.1-53.1h11.2l-37.3 64.3v32.3h-10.6l-.1-32.3zM922 208.8l-36.1-64.3h11.2l30 53.1h.6l31.1-53.1H970l-37.3 64.3v32.3H922v-32.3zM609 153.6h-29.3v-9.2h69v9.2h-29.3V241H609v-87.4zM704 196h-34.7c.1 13.5.6 21.5 1.7 25.5 2.4 8.8 8 11.9 21.5 11.9 7.2 0 15.6-.4 28.8-1.4v9c-11.6 1-19.4 1.4-28.7 1.4-11.8 0-17.6-1.3-23-5.3-8.5-6.3-11-16.6-11-44.4 0-17.5 1.2-28.4 3.7-34.7 2.6-6.8 7.5-11.2 14.4-13.4 4-1.3 8.5-1.7 15.8-1.7 8.8 0 15.9.4 26.4 1.4v9.1c-12.3-1-19.8-1.4-26.5-1.4-13.9 0-19.7 3.4-21.7 13.2-.8 3.6-1.3 10.4-1.3 21.5H704v9.3zM741.8 228.3c9.8 3.6 16.6 5.2 22.5 5.2 15.8 0 24.8-7 24.8-19.4 0-4.6-1.6-8.2-4.6-11-2.4-2.3-6.2-4-13.6-6.6l-9.8-3.2c-14.9-5-21.8-12.6-21.8-24.1 0-16.6 11.9-26.1 32.7-26.1 9.3 0 16.8 1.6 26 5.4l-3.2 8.2c-9.5-3.3-15.5-4.6-22.2-4.6-15.6 0-23 5.3-23 16.6 0 3.7 1 6.6 3.3 8.9 2.7 2.6 4 3.3 14.4 6.8l9.2 3.2c8.3 2.9 12.5 4.9 15.8 7.6 5 4.3 7.4 10.5 7.4 18.2 0 19.1-11.8 29.1-34.3 29.1-9.2 0-16.5-1.6-26.8-5.8l3.2-8.4zM817.8 146.3c10.5-2.3 19-3.3 29-3.3 22.7 0 34 10.3 34 31.1s-11.4 31.2-34 31.2c-6.5 0-12.8-.6-18.5-1.7V241h-10.5v-94.7zm10.4 48.1c7 1.3 12.5 1.9 18.1 1.9 16.5 0 24.7-7.3 24.7-22.1s-8.2-22.1-24.7-22.1c-5.9 0-10.8.4-18.1 1.7v40.6zM979.4 146.3c10.6-2.3 19-3.3 29.1-3.3 16.9 0 26.6 3.9 33.7 13.6 4.9 6.6 7.7 19.6 7.7 36 0 18.5-3.3 31.4-9.8 38.6-7.3 8.2-16.1 11.2-31.7 11.2-10.2 0-18.5-1-29.1-3.3l.1-92.8zm10.4 85.4c8 1.3 12.2 1.7 18.4 1.7 13.8 0 21.2-3.2 26.2-11 3.3-5.6 5-15.2 5-29.7 0-16.2-2-25.8-6.4-31.6-5.3-6.4-12.2-9-24.7-9-6.3 0-11.2.4-18.5 1.7v77.9zM1108.4 196h-34.7c.1 13.5.6 21.5 1.7 25.5 2.4 8.8 8 11.9 21.5 11.9 7.2 0 15.6-.4 28.9-1.4v9c-11.6 1-19.4 1.4-28.7 1.4-11.8 0-17.6-1.3-23-5.3-8.4-6.3-11-16.6-11-44.4 0-17.5 1.2-28.4 3.7-34.7 2.6-6.8 7.5-11.2 14.4-13.4 4-1.3 8.4-1.7 15.8-1.7 8.8 0 15.9.4 26.4 1.4v9.1c-12.4-1-19.8-1.4-26.6-1.4-13.9 0-19.7 3.4-21.7 13.2-.9 3.6-1.3 10.4-1.3 21.5h34.6v9.3zM1138.1 146.3c10.6-2.3 19-3.3 29.1-3.3 22.7 0 33.8 10 33.8 30.2 0 13.8-6 23.2-17.4 27.1l21.2 40.8h-11.6l-20.1-38.6c-2 .3-3.5.3-5.3.3h-19.4v38.4h-10.5v-94.9h.2zm29.4 47.2c16.1 0 23.8-6.6 23.8-20.6 0-14-8.2-20.9-25-20.9-5.6 0-10.5.4-17.9 1.7v39.8h19.1zM340.7 144.5v86.9c13.1-.2 21.3-.6 25.3-1.9 8.9-2.6 12.1-8.7 12.1-23.4 0-7.8-.4-48.5-1.5-61.5h9.2c1 11.3 1.5 51.2 1.5 61.3 0 12.8-1.3 19.2-5.4 25-6.4 9.2-17 10.4-45.2 10.4-17.8 0-28.9-1.2-35.4-4-6.9-2.8-11.3-6.5-13.5-14-1.3-4.4-1.8-9.2-1.8-17.2 0-9.5.4-48.8 1.9-61.7h9.2c-1.5 14.9-1.9 54.5-1.9 61.8 0 15.1 3.5 21.4 13.4 23.6 3.6.9 12.1 1.4 23.5 1.4v-86.7h8.6zM282.8 362.1v-45.7c0-2.7.6-5.1 1.7-7.2 1.2-2.1 2.9-3.7 5-4.9 2.2-1.2 4.6-1.8 7.3-1.8 2.1 0 4 .4 5.6 1.2 1.6.7 3.1 1.7 4.4 3.1l-3.8 3.8c-.9-.9-1.8-1.5-2.8-1.9-.9-.4-2-.7-3.3-.7-2.6 0-4.6.8-6.1 2.3-1.4 1.5-2.1 3.6-2.1 6.3v45.5h-5.9zm-9.8-33.8V323h28.7v5.2H273zm35.4 33.8V323h5.8v39.1h-5.8zm5.8-22.8-2.4-1.1c0-4.9 1.2-8.8 3.6-11.7 2.4-2.9 5.8-4.3 10-4.3 1.9 0 3.7.4 5.3 1.1 1.6.7 3.1 1.7 4.5 3.2l-3.8 4.1c-.9-1.1-2-1.8-3.2-2.2-1.1-.4-2.4-.7-3.8-.7-3 0-5.4 1-7.3 3-1.9 1.9-2.9 4.8-2.9 8.6zm43.5 23.6c-3.8 0-7.2-.9-10.3-2.7-3-1.8-5.5-4.3-7.3-7.4-1.8-3.1-2.7-6.6-2.7-10.4 0-3.8.9-7.2 2.7-10.2 1.8-3 4.3-5.5 7.3-7.2 3.1-1.8 6.5-2.7 10.3-2.7 3.8 0 7.3.9 10.3 2.7 3 1.8 5.5 4.2 7.2 7.3 1.8 3 2.7 6.5 2.7 10.2 0 3.9-.9 7.4-2.7 10.5-1.8 3-4.2 5.5-7.2 7.3-3.1 1.7-6.5 2.6-10.3 2.6zm0-5.6c2.8 0 5.2-.6 7.3-1.9 2.2-1.3 3.8-3 5.1-5.3 1.3-2.3 1.9-4.8 1.9-7.6s-.6-5.3-1.9-7.5c-1.2-2.2-2.9-4-5.1-5.2-2.1-1.3-4.5-1.9-7.3-1.9-2.7 0-5.2.6-7.3 1.9-2.2 1.3-3.8 3-5.1 5.2-1.2 2.2-1.8 4.7-1.8 7.5 0 2.9.6 5.5 1.8 7.7 1.2 2.2 2.9 4 5.1 5.2 2.1 1.2 4.5 1.9 7.3 1.9zm29.5 4.8V323h5.8v39.1h-5.8zm26.8 0v-23.9c0-3.2-1-5.8-2.9-7.6-1.9-1.9-4.4-2.9-7.3-2.9-2 0-3.8.4-5.5 1.3-1.6.8-2.9 2-3.9 3.6-.9 1.6-1.4 3.4-1.4 5.6l-2.7-1.1c0-3 .7-5.6 2-7.8s3.1-3.9 5.3-5.2c2.3-1.2 4.8-1.8 7.6-1.8s5.2.6 7.4 1.8c2.2 1.2 4 2.9 5.2 5.2 1.3 2.2 2 4.8 2 7.9v25H414zm26.9 0v-23.9c0-3.2-1-5.8-2.9-7.6-1.9-1.9-4.4-2.9-7.4-2.9-1.9 0-3.7.4-5.4 1.3-1.6.8-2.9 2-3.9 3.6-.9 1.6-1.4 3.4-1.4 5.6l-3.5-1.1c.2-3 .9-5.6 2.3-7.8s3.3-3.9 5.6-5.2c2.3-1.2 4.9-1.8 7.6-1.8 2.8 0 5.3.6 7.5 1.8 2.3 1.2 4 2.9 5.3 5.2 1.3 2.2 2 4.8 2 7.9v25h-5.8z" />
    <defs>
      <path id="SVGID_1_" d="M587.1 308.6h295.8v76.1H587.1z" />
    </defs>
    <clipPath id="SVGID_00000010284348905260145250000010916803210133730197_">
      <use
        xlinkHref="#SVGID_1_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000010284348905260145250000010916803210133730197_)",
      }}
    >
      <path d="M587.1 365.9v-57.3h6.1v57.3h-6.1zm4-51.5v-5.8h32.2v5.8h-32.2zm0 24.9v-5.8h30.8v5.8h-30.8zM631.3 365.9v-57.3h5.8v57.3h-5.8zM653.2 384.7l7.5-18.9h-1.3l-15-41.9h5.9l12.6 36.1 13.2-36.1h5.9l-23 60.8h-5.8zM743.1 323.9l-12.6 41.9h-6.8l-9.8-31.8-9.8 31.8h-6.8l-12.6-41.9h5.9l10.3 35.8 10.7-35.8h4.7l10.6 35.8 10.3-35.8h5.9zM755.6 308.6V330c4.7-3.5 9.9-6 14.8-6 6.9 0 10.9 3.2 10.9 10.7v31.2h-5.6v-29.7c0-4.9-2.1-6.7-6.8-6.7-3.7 0-8.7 2-13.1 5.4v31h-5.6v-57.3h5.4zM808.6 365.7c-3.8 0-7.2-.9-10.2-2.7-3-1.8-5.3-4.3-7.1-7.5-1.7-3.2-2.6-6.8-2.6-10.7 0-4 .9-7.5 2.6-10.6 1.7-3.2 4-5.6 7-7.5 2.9-1.8 6.2-2.7 9.8-2.7 3.4 0 6.4.8 9.1 2.5 2.6 1.6 4.7 3.9 6.2 6.9 1.5 2.9 2.3 6.3 2.3 10.1 0 .5 0 1-.1 1.6-.1.6-.2 1.3-.3 2.1h-32.6v-5.1h29.5l-2 1.9c.1-3-.4-5.5-1.4-7.6-1-2.1-2.4-3.8-4.2-4.9-1.8-1.2-4.1-1.7-6.7-1.7s-5.1.6-7.1 1.9c-2 1.3-3.6 3-4.8 5.2-1.1 2.2-1.7 4.9-1.7 8 0 3.1.6 5.8 1.8 8.1 1.2 2.3 2.9 4.1 5 5.4 2.2 1.3 4.7 2 7.5 2 2.3 0 4.4-.4 6.3-1.3 1.9-.9 3.5-2.2 4.9-4l3.6 3.9c-1.8 2.2-3.9 3.9-6.5 5.2-2.5.9-5.3 1.5-8.3 1.5zM851.6 365.7c-3.8 0-7.2-.9-10.2-2.7-3-1.8-5.3-4.3-7.1-7.5-1.7-3.2-2.6-6.8-2.6-10.7 0-4 .9-7.5 2.6-10.6 1.7-3.2 4-5.6 7-7.5 2.9-1.8 6.2-2.7 9.8-2.7 3.4 0 6.4.8 9.1 2.5 2.6 1.6 4.7 3.9 6.2 6.9 1.5 2.9 2.3 6.3 2.3 10.1 0 .5 0 1-.1 1.6-.1.6-.2 1.3-.3 2.1h-32.6v-5.1h29.5l-2 1.9c.1-3-.4-5.5-1.4-7.6-1-2.1-2.4-3.8-4.2-4.9-1.8-1.2-4.1-1.7-6.7-1.7-2.6 0-5.1.6-7.1 1.9-2 1.3-3.6 3-4.8 5.2-1.1 2.2-1.7 4.9-1.7 8 0 3.1.6 5.8 1.8 8.1 1.2 2.3 2.9 4.1 5 5.4 2.2 1.3 4.7 2 7.5 2 2.3 0 4.4-.4 6.3-1.3 1.9-.9 3.5-2.2 4.9-4l3.6 3.9c-1.8 2.2-3.9 3.9-6.5 5.2-2.5.9-5.3 1.5-8.3 1.5zM882.8 308.6v57.3h-5.6v-57.3h5.6z" />
    </g>
    <defs>
      <path
        id="SVGID_00000114759087433399267710000011793778111300068006_"
        d="M478.8 292.2h90.3v89.5h-90.3z"
      />
    </defs>
    <clipPath id="SVGID_00000109726180379226157260000009949871475513407664_">
      <use
        xlinkHref="#SVGID_00000114759087433399267710000011793778111300068006_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath:
          "url(#SVGID_00000109726180379226157260000009949871475513407664_)",
      }}
    >
      <linearGradient
        id="SVGID_00000043433290066454848120000013724688672051917215_"
        x1={392.429}
        x2={177.56}
        y1={271.223}
        y2={432.837}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#ad9cfc",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M568.6 344c2.5-21.7-12.1-43.5-35.7-47.4-9.7-1.7-20 .2-28.6 5.1-3.6 2.2-1.1.7-4 2.6-18.7 13.5-16.6 38-.5 48.5-9.4-4.6-15.4-13.9-16.6-24-.8-9.6 3-19.4 11.3-26.2 31.8-26 79.7 0 74.1 41.4z"
        style={{
          fill: "url(#SVGID_00000043433290066454848120000013724688672051917215_)",
        }}
      />
      <linearGradient
        id="SVGID_00000093860803060812405600000006224972503267437478_"
        x1={384.106}
        x2={182.888}
        y1={276.085}
        y2={427.084}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#ad9cfc",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M567.5 348.2c5.6-30.9-25.3-55.9-54.7-44-.9.4-2.3 1-3.2 1.5-23.2 12.3-22.1 38-6.4 48.5-.7-.3-1.4-.5-2.1-.8-17.6-11-19-38.5 4.7-50.9 8.1-4.4 17.8-6 26.9-4.5 24.5 4 39.1 27.6 34.8 50.2z"
        style={{
          fill: "url(#SVGID_00000093860803060812405600000006224972503267437478_)",
        }}
      />
      <linearGradient
        id="SVGID_00000119098497393698800890000007693310461589534650_"
        x1={373.581}
        x2={188.5}
        y1={280.419}
        y2={421.835}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#ad9cfc",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M566.7 349.7c2.5-14-3.4-28.9-15.8-37.1-14.9-10.1-35.9-7.7-47.9 5.8-9.1 10.3-9.2 26.7 1.2 36.2-.3-.1-.6-.2-.8-.3-14.2-10.1-14.4-31.1-1-42.3 1.6-1.5 6-4.6 9.3-5.9 7.2-3.3 15.5-4.3 23.4-2.9 22.4 4.1 35.6 25.7 31.6 46.5z"
        style={{
          fill: "url(#SVGID_00000119098497393698800890000007693310461589534650_)",
        }}
      />
      <linearGradient
        id="SVGID_00000086654334929382984670000015904329017411551122_"
        x1={362.291}
        x2={194.011}
        y1={284.307}
        y2={416.593}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#ad9cfc",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M565.8 351.7c3.4-17.1-7.3-35-25.4-39.3-22.2-5.4-44.9 13.2-38.9 34.9.7 2.6 1.8 5.1 3.3 7.3-.1 0-.3-.1-.4-.1-10.8-10.9-9.6-29.2 3.7-39.2 11.9-9.5 29.6-10.2 42.2-1.7 12.6 8.4 18.4 23.8 15.5 38.1z"
        style={{
          fill: "url(#SVGID_00000086654334929382984670000015904329017411551122_)",
        }}
      />
      <linearGradient
        id="SVGID_00000174587878030398775080000009552268325474385327_"
        x1={350.65}
        x2={199.313}
        y1={287.63}
        y2={411.572}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#ad9cfc",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M565.7 348.1c-.2-27.8-31.9-41-51.5-23.6-8.4 7.5-12.2 19.4-9.3 30.3-.1 0-.1 0-.2-.1-6.9-11.9-3.3-26.3 6.5-34.2 11.1-9.4 27.9-10.2 39.9-2 9.9 6.7 15.1 18.2 14.6 29.6z"
        style={{
          fill: "url(#SVGID_00000174587878030398775080000009552268325474385327_)",
        }}
      />
      <linearGradient
        id="SVGID_00000124132847271681862820000004965150929783959738_"
        x1={137.54}
        x2={271.139}
        y1={373.748}
        y2={366.846}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#d1c8fb",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M479.2 329.9c-2.5 21.7 12.1 43.5 35.7 47.4 9.7 1.7 20-.2 28.6-5.1 3.6-2.2 1.1-.7 4-2.6 18.7-13.5 16.6-38 .5-48.5 9.4 4.6 15.4 13.9 16.6 24 .8 9.6-3 19.4-11.3 26.2-31.8 26.1-79.6 0-74.1-41.4z"
        style={{
          fill: "url(#SVGID_00000124132847271681862820000004965150929783959738_)",
        }}
      />
      <linearGradient
        id="SVGID_00000150795164658779864370000017531476449594443955_"
        x1={141.466}
        x2={266.373}
        y1={376.684}
        y2={370.247}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#d1c8fb",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M480.4 325.8c-5.6 30.9 25.3 55.9 54.7 44 .9-.4 2.3-1 3.2-1.5 23.2-12.3 22.1-38 6.4-48.5.7.3 1.4.5 2.1.8 17.6 11 19 38.5-4.7 50.9-8.1 4.4-17.8 6-26.9 4.5-24.6-4.1-39.2-27.6-34.8-50.2z"
        style={{
          fill: "url(#SVGID_00000150795164658779864370000017531476449594443955_)",
        }}
      />
      <linearGradient
        id="SVGID_00000169558599795947965640000016458436719080147075_"
        x1={145.324}
        x2={261.721}
        y1={379.243}
        y2={373.135}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#d1c8fb",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M481.2 324.2c-2.5 14 3.4 28.9 15.8 37.1 14.9 10.1 35.9 7.7 47.9-5.8 9.1-10.3 9.2-26.7-1.2-36.2.3.1.6.2.8.3 14.2 10.1 14.4 31.1 1 42.3-1.6 1.5-6 4.6-9.3 5.9-7.2 3.3-15.5 4.3-23.4 2.9-22.4-4.1-35.7-25.7-31.6-46.5z"
        style={{
          fill: "url(#SVGID_00000169558599795947965640000016458436719080147075_)",
        }}
      />
      <linearGradient
        id="SVGID_00000065757919969706273610000002494946561141576835_"
        x1={149.11}
        x2={257.207}
        y1={381.772}
        y2={375.935}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#d1c8fb",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M482.1 322.2c-3.4 17.1 7.3 35 25.4 39.3 22.2 5.4 44.9-13.2 38.9-34.9-.7-2.6-1.8-5.1-3.3-7.3.1 0 .3.1.4.1 10.8 10.9 9.6 29.2-3.7 39.2-11.9 9.5-29.6 10.2-42.2 1.7-12.7-8.3-18.5-23.8-15.5-38.1z"
        style={{
          fill: "url(#SVGID_00000065757919969706273610000002494946561141576835_)",
        }}
      />
      <linearGradient
        id="SVGID_00000139984620660301567750000008631948570496806074_"
        x1={152.683}
        x2={253.041}
        y1={384.308}
        y2={378.663}
        gradientTransform="matrix(1 0 0 -1 294 719.797)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0.1}
          style={{
            stopColor: "#d1c8fb",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#1c55fb",
          }}
        />
      </linearGradient>
      <path
        d="M482.2 325.8c.2 27.8 31.9 41 51.5 23.6 8.4-7.5 12.2-19.4 9.3-30.3.1 0 .1 0 .2.1 6.9 11.9 3.3 26.3-6.5 34.2-11.1 9.4-27.9 10.2-39.9 2-9.9-6.7-15.2-18.1-14.6-29.6z"
        style={{
          fill: "url(#SVGID_00000139984620660301567750000008631948570496806074_)",
        }}
      />
    </g>
  </svg>
)
export default SvgComponent
